import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { usePodcast } from "../hooks/usePodcast";

interface IParamsType {
  id: string;
}

export const ManagePodcast = () => {
  const [podcastId, setPodcastId] = useState("");
  const params = useParams<IParamsType>();
  const [queryReadyToStart, { data, loading }] = usePodcast();

  useEffect(() => {
    setPodcastId(params.id);
    queryReadyToStart({
      variables: {
        input: {
          podcastId: +podcastId,
        },
      },
    });
  }, [params.id, podcastId, queryReadyToStart]);

  return (
    <div>
      <Helmet>
        <title>Manage Podcast | Pocast</title>
      </Helmet>

      {!loading && (
        <div className="h-screen bg-black text-white">
          <div className="flex flex-col justify-center items-center text-center pt-10">
            <div className="w-full max-w-screen-sm px-5 text-center flex flex-col justify-between ">
              <div className="relative mb-2">
                <div className="relative mb-3">
                  <div className="text-left text-3xl tracking-wider leading-10 pb-1 text-purple-700 ">Manage Podcast</div>
                </div>
                <div className="w-full bg-gray-700 flex mb-3 p-3 rounded-lg justify-between items-start ">
                  <div className="flex flex-col items-start">
                    <div className="text-xl text-black font-bold text-center tracking-wider mb-2">
                      {data?.getPodcastById.podcast?.title}
                    </div>
                    <div className="text-md text-gray-200 mb-2">
                      Total Episodes: {data?.getPodcastById.podcast?.episodes ? data?.getPodcastById.podcast.episodes.length : 0}
                    </div>
                    <div className=" text-md text-gray-200 mb-2">Rating: {data?.getPodcastById.podcast?.rating}</div>
                    <div className="  text-sm text-gray-300">Last updated: {data?.getPodcastById.podcast?.updatedAt}</div>
                  </div>
                  <Link to={`/podcast/${podcastId}/edit`} className="py-1 px-3 bg-purple-800 rounded-lg hover:bg-purple-900">
                    Edit
                  </Link>
                </div>
              </div>
              <div className="h-0.5 w-full bg-gray-300 mb-2"></div>
              <div className="relative">
                <div className="flex items-center justify-between w-full  mb-5">
                  <div className="text-left   text-purple-700 ">
                    <div className="text-xl tracking-wider leading-10">Episodes</div>
                    <div>Total Episodes: {data?.getPodcastById.podcast?.episodes ? data?.getPodcastById.podcast.episodes.length : 0}</div>
                  </div>
                  <Link to={`/podcast/${podcastId}/create-episode`} className="py-1 px-3 bg-purple-800 rounded-lg hover:bg-purple-900">
                    Upload New Episode
                  </Link>
                </div>
                {data?.getPodcastById.podcast?.episodes &&
                  data.getPodcastById.podcast.episodes.map((episode) => (
                    <div key={episode.id} className="w-full bg-gray-700 flex mb-3 p-3 rounded-lg justify-between items-start ">
                      <div className="flex flex-col items-start">
                        <div className="font-bold text-xl text-black text-center tracking-wider mb-2">{episode.title}</div>
                        <div className="text-sm text-gray-300">Last updated: {episode.updatedAt}</div>
                      </div>
                      <Link
                        to={`/podcast/${podcastId}/edit-episode/${episode.id}`}
                        className="py-1 px-3 bg-purple-800 rounded-lg hover:bg-purple-900"
                      >
                        Edit
                      </Link>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
